<div id="todo" class="page-layout carded left-sidebar inner-scroll">


    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="customer-main-sidebar" position="left" lockedOpen="gt-md">
        <customer-resources-sidebar (filteredCategory)="filterByCategory($event)"></customer-resources-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CONTENT -->
    <div class="content" [ngClass]="this.view" style="overflow-y: scroll;">

        <div class="cards" fxLayout="row wrap" fxLayout.xs="column wrap">
            <div class="card" *ngFor="let row of rows" fxFlex="33">
                <!-- PREVIEW -->
                <div class="card-preview" fxFlex="100">

                    <div class="fuse-card" fxFlex="100">

                        <div class="p-16 pt-0 line-height-1.75">
                            <h3>{{row.name}}</h3>
                            <h4 *ngIf="row.assignedCard">{{row.assignedCard.cardNumber}}</h4>
                            <h5 *ngIf="row.assignedUser">
                                {{row.assignedUser.firstName}} {{row.assignedUser.lastName}}
                            </h5>
                        </div>

                        <div class="p-8 pt-0" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="row.assignedCard">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <a mat-button color="accent" routerLink="/customers/cards/{{row.assignedCard.id}}/history/{{row.assignedUser.id}}">{{'CARD HISTORY'|translate}}</a>
                                <a routerLink="/customers/cards/{{row.assignedUser.id}}">{{'USER CARDS'|translate}}</a>&nbsp;
                            </div>

                        </div>

                    </div>

                </div>
                <!-- / PREVIEW -->
            </div>


        </div>
    </div>
</div>
